import PropTypes from 'prop-types';
import { price } from 'utils/helpers';

const ProductCardPrice = ({
  fromToggle = undefined,
  basePrice,
  salePrice = undefined,
  priceDefinition = undefined,
}) => {
  const displayPrice = salePrice || basePrice;
  const discount = basePrice - salePrice;
  return (
    <div className="space-y-2">
      <p className="text-xx-small">
        {fromToggle && 'From '}
        <strong className="h6 text-primary">
          {price(displayPrice, {
            fromCents: false,
          })}
        </strong>
        {priceDefinition ? ` ${priceDefinition}` : ''}
      </p>
      {salePrice && (
        <p className="text-xx-small">
          Normally{' '}
          <span className="text-line-through">${basePrice.toFixed(2)}</span>.{' '}
          <strong>Save ${discount.toFixed(2)}</strong>.
        </p>
      )}
    </div>
  );
};

ProductCardPrice.propTypes = {
  fromToggle: PropTypes.bool,
  basePrice: PropTypes.number,
  salePrice: PropTypes.number,
  priceDefinition: PropTypes.string,
};

export default ProductCardPrice;
